/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './index.scss';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from '../src/redux/store';

import App from './App';

const root = createRoot(document.getElementById('recApp') as HTMLElement);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
